export default "assets/images/icons/square-452e7e39.svg";